import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "155",
  height: "155",
  fill: "none",
  viewBox: "0 0 155 155"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DBD1FA",
      d: "m77.242 0 77.242 50.98-77.242 103.504L0 50.98 77.242 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A78FEF",
      d: "m77.242 76.69 77.242-25.414-77.242 103.198L0 51.276 77.242 76.69Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A78FEF",
      d: "m77.554 0 76.93 50.98-76.93 103.504V0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6939F9",
      d: "m77.554 76.69 76.93-25.414-76.93 103.198V76.69Z"
    }, null, -1)
  ])))
}
export default { render: render }